import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PuchaseAnalysisService {

  private endpoint = environment.endpoint;

  constructor(
    private http: HttpClient
  ) { }

  getSaleReportByDateRange(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/sale-daily-report/between`, { params: filters }));
  }

  getProductSummaryReportByGroup(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-daily-report/group/summary`, { params: filters }));
  }

  searchProduct(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/search`, { params: filters }));
  }

  getAllProduct(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product/all`, { params: filters }));
  }

  getProductDailyReportByGroup(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/product-daily-report/group/all`, { params: filters }));
  }

  addProductTag(body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product/tags/add`, body));
  }

  removeProductTag(body: any) {
    return firstValueFrom(this.http.patch(`${this.endpoint}/product/tags/remove`, body));
  }

  getProductTag(filters: any) {
    return firstValueFrom(this.http.get(`${this.endpoint}/tags`, { params: filters }));
  }

  createTag(body: any) {
    return firstValueFrom(this.http.post(`${this.endpoint}/tags`, body));
  }

  removeTag(tag: string) {
    return firstValueFrom(this.http.delete(`${this.endpoint}/tags/${tag}`));
  }

}
